module.exports = __webpack_public_path__ + "img/banner-home.9aa741aa.svg";